import { EventRepository } from '~repositories/EventRepository';
import { events } from '@estee/elc-service-bus';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';

export class CartLoggedInUseCase {
    private eventRepository: EventRepository;

    constructor() {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
    }

    public execute = () => {
        const cartLoggedInPayload = {
            event_name: 'login_success',
            event_category: 'checkout',
            event_action: 'login success'
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.CART_LOGGED_IN,
            type: 'link',
            payload: cartLoggedInPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
